import { Controller } from "@hotwired/stimulus"

// Live search that keeps the phone keyboard up.
//
// The obvious build is a form plus `requestSubmit()` on a debounce, but iOS
// treats any form submission as the end of text entry and dismisses the
// keyboard -- Turbo intercepting the submit doesn't stop that. After a
// character or two the keyboard would drop and the field lost focus.
//
// Navigating the frame by setting its `src` is the same request and the same
// frame render, with no submit event for iOS to react to, so the keyboard
// stays up and the caret stays put.
export default class extends Controller {
  static targets = ["input", "frame"]
  static values = {
    url: String,
    param: { type: String, default: "query" },
    delay: { type: Number, default: 300 }
  }

  search() {
    clearTimeout(this.#timeout)
    this.#timeout = setTimeout(() => this.#load(), this.delayValue)
  }

  // Enter on the phone's "search" key shouldn't reload the page; the debounced
  // request already has the answer on screen.
  preventSubmit(event) {
    event.preventDefault()
    this.#load()
  }

  #load() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, this.inputTarget.value)
    const target = `${url.pathname}${url.search}`

    // Backspacing to a value we already fetched shouldn't re-fetch it.
    if (target === this.#loaded) return

    this.#loaded = target
    this.frameTarget.src = target
  }

  disconnect() {
    clearTimeout(this.#timeout)
  }

  #timeout
  #loaded
}
